export type SocialProvider = 'kakao' | 'naver' | 'google';

interface ProviderConfig {
  authUrl: string;
  clientId: string;
  scope: string;
  label: string;
  color: string;
  textColor: string;
}

const REDIRECT_BASE = `${window.location.origin}/auth/callback`;

const providers: Record<SocialProvider, ProviderConfig> = {
  kakao: {
    authUrl: 'https://kauth.kakao.com/oauth/authorize',
    clientId: import.meta.env.VITE_KAKAO_CLIENT_ID || '',
    scope: 'profile_nickname,profile_image,account_email',
    label: '카카오 로그인',
    color: '#FEE500',
    textColor: '#000000',
  },
  naver: {
    authUrl: 'https://nid.naver.com/oauth2.0/authorize',
    clientId: import.meta.env.VITE_NAVER_CLIENT_ID || '',
    scope: 'name,email,profile_image',
    label: '네이버 로그인',
    color: '#03C75A',
    textColor: '#FFFFFF',
  },
  google: {
    authUrl: 'https://accounts.google.com/o/oauth2/v2/auth',
    clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
    scope: 'openid email profile',
    label: '구글 로그인',
    color: '#FFFFFF',
    textColor: '#374151',
  },
};

export function buildAuthUrl(provider: SocialProvider): string {
  const config = providers[provider];
  const redirectUri = `${REDIRECT_BASE}/${provider}`;
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: config.clientId,
    redirect_uri: redirectUri,
    scope: config.scope,
  });

  // 네이버는 state 필수
  if (provider === 'naver') {
    const state = crypto.randomUUID();
    sessionStorage.setItem('naver_oauth_state', state);
    params.set('state', state);
  }

  return `${config.authUrl}?${params.toString()}`;
}

export function getRedirectUri(provider: SocialProvider): string {
  return `${REDIRECT_BASE}/${provider}`;
}

export { providers };
